export class WorkspaceNetworkingSettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vpcPeering",
            "baseName": "vpcPeering",
            "type": "WorkspaceNetworkingSettingsVpcPeering",
            "format": ""
        },
        {
            "name": "privateLinks",
            "baseName": "privateLinks",
            "type": "Array<PrivateLink>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceNetworkingSettings.attributeTypeMap;
    }
    constructor() {
    }
}
